import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const presenceApi = {
  /**
   * UPDATE PRESENCE (Heartbeat)
   * Endpoint: POST /api/feed/presence/heartbeat
   * Body: {} (empty, auth from token)
   * Response: { success: true, status: 'online', lastSeen: Date }
   */
  updatePresence: async () => {
    try {
      return await apiClient.post("/feed/presence/heartbeat");
    } catch (error) {
      // Silent fail for heartbeat
      return { success: false };
    }
  },

  /**
   * GET USER PRESENCE STATUS
   * Endpoint: GET /api/feed/presence/status/:userId
   * Response: { userId, status: 'online'|'offline', lastSeen: Date }
   */
  getUserStatus: async (userId) => {
    try {
      return await apiClient.get(`/feed/presence/status/${userId}`);
    } catch (error) {
      // Silent fail, return offline status
      return { success: false, status: "offline" };
    }
  },

  /**
   * GET BATCH USER STATUSES
   * Endpoint: POST /api/feed/presence/batch-status
   * Body: { userIds: ['id1', 'id2', ...] }
   * Response: { statuses: { userId: { status, lastSeen }, ... } }
   */
  getBatchStatus: async (userIds) => {
    try {
      if (!userIds || userIds.length === 0) {
        return { success: true, statuses: {} };
      }
      return await apiClient.post("/feed/presence/batch-status", { userIds });
    } catch (error) {
      // Silent fail, return empty statuses
      return { success: false, statuses: {} };
    }
  },

  /**
   * SET STATUS (Optional - for explicit status changes)
   * Endpoint: POST /api/feed/presence/status
   * Body: { status: 'online'|'offline'|'away' }
   */
  setStatus: async (status) => {
    try {
      return await apiClient.post("/feed/presence/status", { status });
    } catch (error) {
      // Silent fail
      return { success: false };
    }
  },
};

export default presenceApi;
